namespace TabAurous.Production {
    export interface ProductionItemsForm {
        DepartmentId: Serenity.LookupEditor;
        BagNo: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        Line_No: Serenity.StringEditor;
        Pieces: Serenity.IntegerEditor;
        OrderNo: Serenity.StringEditor;
        Weight: WeightEditor;
        CustomerName: Serenity.StringEditor;
        NetWeight: WeightEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: Serenity.DecimalEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: Serenity.DecimalEditor;
        OtherPieces: Serenity.IntegerEditor;
        OtherWeight: WeightEditor;
        Parts: Serenity.IntegerEditor;
        TransDate: Serenity.DateEditor;
        VoucherNo: Serenity.StringEditor;
        Attribute: Serenity.StringEditor;
        ProductId: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        TreeId: Serenity.StringEditor;
        TreeItemId: Serenity.StringEditor;
        TreeNo: Serenity.StringEditor;
        BOMDetails: ProductionBOMEditor;
        PureWeight: WeightEditor;
        Purity: Serenity.DecimalEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        RefVoucherId: Serenity.IntegerEditor;
        RefTransId: Serenity.StringEditor;
        RefTransItemId: Serenity.StringEditor;
        OrderTypeId: Serenity.IntegerEditor;
        OrderTransId: Serenity.IntegerEditor;
        OrderTransItemId: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
    }

    export class ProductionItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Production.ProductionItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductionItemsForm.init)  {
                ProductionItemsForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = WeightEditor;
                var w4 = s.DecimalEditor;
                var w5 = s.DateEditor;
                var w6 = ProductionBOMEditor;

                Q.initFormType(ProductionItemsForm, [
                    'DepartmentId', w0,
                    'BagNo', w1,
                    'ProductCode', w1,
                    'ItemTypeId', w2,
                    'Line_No', w1,
                    'Pieces', w2,
                    'OrderNo', w1,
                    'Weight', w3,
                    'CustomerName', w1,
                    'NetWeight', w3,
                    'DiamondPieces', w2,
                    'DiamondWeight', w4,
                    'StonePieces', w2,
                    'StoneWeight', w4,
                    'OtherPieces', w2,
                    'OtherWeight', w3,
                    'Parts', w2,
                    'TransDate', w5,
                    'VoucherNo', w1,
                    'Attribute', w1,
                    'ProductId', w1,
                    'AttributeId', w1,
                    'TreeId', w1,
                    'TreeItemId', w1,
                    'TreeNo', w1,
                    'BOMDetails', w6,
                    'PureWeight', w3,
                    'Purity', w4,
                    'CompanyId', w2,
                    'FinancialYearId', w2,
                    'RefVoucherId', w2,
                    'RefTransId', w1,
                    'RefTransItemId', w1,
                    'OrderTypeId', w2,
                    'OrderTransId', w2,
                    'OrderTransItemId', w2,
                    'UserId', w2
                ]);
            }
        }
    }
}
